document.addEventListener('DOMContentLoaded', function () {
  // Grab all collapsible <details> in the product accordions
  const accordionDetails = document.querySelectorAll('.product__accordion details');

  if (!accordionDetails.length) return;

  accordionDetails.forEach(function (detail) {
    detail.addEventListener('toggle', function () {
      // Only act when a row is being opened
      if (!detail.open) return;

      accordionDetails.forEach(function (other) {
        if (other !== detail && other.open) {
          other.open = false; // close any other open rows
        }
      });
    });
  });
});
